import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

import LaptopDashboardImage from '../../images/laptop-dashboard.png';

const CampaignAnalyticsNoneContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
  margin-block-end: 20%;
  gap: 16px;
`;

const CenteredImage = styled.img`
  width: 300px;
  height: 300px;
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  text-align: center;
`;

export const CampaignAnalyticsNone = () => {
  return (
    <CampaignAnalyticsNoneContainer>
      <CenteredImage src={LaptopDashboardImage} />
      <InformationContainer>
        <Typography.Heading2>
          <FormattedMessage id="campaigns.analytics.none.title" />
        </Typography.Heading2>
        <Typography.Body2>
          <FormattedMessage id="campaigns.analytics.none.description" />
        </Typography.Body2>
      </InformationContainer>
    </CampaignAnalyticsNoneContainer>
  );
};
